
import { Flex, Text } from "@chakra-ui/react";

const LOADER_COLOR = "#14B8A6";

type AppLoaderProps = {
  size?: number;
  text?: string;
  showText?: boolean;
  fullPage?: boolean;
  background?: string;
  textColor?: string;
};

const GlobalSpinner = ({
  size = 84,
  text,
  showText = false,
  fullPage = false,
  background = "transparent",
  textColor = "gray.500",
}: AppLoaderProps) => {
  const shouldShowText = showText && Boolean(text);

  const loader = (
    <Flex
      direction="column"
      align="center"
      justify="center"
      gap={4}
      w="fit-content"
      maxW="100%"
      mx="auto"
      role="status"
      aria-label={text || "Loading"}
      aria-live="polite"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 44 44"
        fill="none"
        stroke={LOADER_COLOR}
        xmlns="http://www.w3.org/2000/svg"
        style={{
          display: "block",
          flexShrink: 0,
          maxWidth: "100%",
          overflow: "hidden",
        }}
        aria-hidden="true"
      >
        <g fill="none" fillRule="evenodd" strokeWidth="2">
          <circle cx="22" cy="22" r="1">
            <animate
              attributeName="r"
              begin="0s"
              calcMode="spline"
              dur="1.8s"
              keySplines="0.165, 0.84, 0.44, 1"
              keyTimes="0; 1"
              repeatCount="indefinite"
              values="1; 20"
            />
            <animate
              attributeName="stroke-opacity"
              begin="0s"
              calcMode="spline"
              dur="1.8s"
              keySplines="0.3, 0.61, 0.355, 1"
              keyTimes="0; 1"
              repeatCount="indefinite"
              values="1; 0"
            />
          </circle>

          <circle cx="22" cy="22" r="1">
            <animate
              attributeName="r"
              begin="-0.9s"
              calcMode="spline"
              dur="1.8s"
              keySplines="0.165, 0.84, 0.44, 1"
              keyTimes="0; 1"
              repeatCount="indefinite"
              values="1; 20"
            />
            <animate
              attributeName="stroke-opacity"
              begin="-0.9s"
              calcMode="spline"
              dur="1.8s"
              keySplines="0.3, 0.61, 0.355, 1"
              keyTimes="0; 1"
              repeatCount="indefinite"
              values="1; 0"
            />
          </circle>
        </g>
      </svg>

      {shouldShowText && (
        <Text
          fontSize="sm"
          fontWeight="700"
          color={textColor}
          textAlign="center"
        >
          {text}
        </Text>
      )}
    </Flex>
  );

  if (fullPage) {
    return (
      <Flex
        minH="100vh"
        w="100%"
        align="center"
        justify="center"
        bg={background}
      >
        {loader}
      </Flex>
    );
  }

  return loader;
};

export default GlobalSpinner;
